export const networks = [
  {
    chainId: 'cube_47-5',
    faucetUrl: process.env.REACT_APP_FOUCET_URL || 'https://cube-faucet-api.xpla.io/claim',
    explorerUrl: 'https://explorer.xpla.io'
  }
];
